import React from 'react'
import { Button } from 'react-bootstrap'

const BillingPaymentMethod = ({
  fleetBillingUrl
}) => {
  return (
    <div>
      <Button
        variant="primary"
        onClick={() => {
          window.open(fleetBillingUrl, '_blank');
        }}
        className='btn-save mt-5'
      >
        View Payment Methods
      </Button>
    </div>
  )
}

export default BillingPaymentMethod